import React, { Component } from 'react';
import { NavLink } from 'react-router-dom'
import { Form, Input, Button, Icon, Checkbox } from 'antd';

export default class RegisterForm extends Component {
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.onSubmit({
                    email: values.email,
                    password: values.password, 
                    name: values.name
                });
                this.props.form.resetFields(['name', 'email', 'password', 'tou']);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { loading } = this.props;

        return (
            <Form onSubmit={this.handleSubmit} className="login-form" style={styles.form}>            
                <Form.Item>
                    {getFieldDecorator('name', {
                        rules: [{ required: true, message: 'Namn sakans!' }]
                    })(
                        <Input prefix={<Icon type="user" style={styles.input} />} placeholder="Namn" />
                    )}
                </Form.Item>
                <Form.Item>
                    {getFieldDecorator('email', {
                        rules: [
                            { required: true, message: 'Email saknas!' },
                            { pattern: new RegExp("[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"), message: 'Felaktig email!' }
                        ]
                    })(
                        <Input prefix={<Icon type="mail" style={styles.input} />} placeholder="E-post" />
                    )}
                </Form.Item>
                <Form.Item>
                    {getFieldDecorator('password', {
                        rules: [
                            { 
                                required: true, message: 'Lösenord saknas!'
                            },
                            {
                                pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/, message: 'Minst en stor bokstav, en liten bokstav samt en siffra',
                            },
                            {
                                min: 6, message: 'Minst sex tecken'
                            }
                        ],
                    })(
                        <Input prefix={<Icon type="lock" style={styles.input} />} type="password" placeholder="Lösenord" />
                    )}
                </Form.Item>
                <Form.Item>
                    {getFieldDecorator('tou', {
                        valuePropName: 'checked',
                        rules: [
                            { 
                                required: true, message: 'Du måste acceptera användarvillkoren.'
                            }
                        ],
                    })(
                        <Checkbox>Jag har läst och accepterar <a href="https://cdn.varmasverige.se/assets/terms-of-use.pdf" target="blank">användarvillkoren</a>.</Checkbox>
                    )}

                    <div>Har du redan ett konto? <NavLink to="/auth/login">Logga in</NavLink></div> 
                    <Button type="primary" block loading={loading} htmlType="submit" className="login-form-button">
                        Registrera
                    </Button>
                </Form.Item>
            </Form>
        );
    };
}

const styles = {
    input: { color: 'rgba(0,0,0,.25)' }
};


// WEBPACK FOOTER //
// ./src/screens/auth/components/register/RegisterForm.js